export const sections = [
  {
    id: "about",
    name: "About Me: Uzoma Ogbor",
    content: [
      <div className="flex flex-col justify-start items-start gap-2 md:gap-5">
        <div className="flex flex-col justify-start items-start">
        <p>Hello!</p>
        <p>
          I'm Uzoma Ogbor, a Nigerian based Digital Illustrator specialising in
          2D Character Illustration, Character Concept design, Comicbook and
          Book cover Illustration.
        </p>
        </div>

        
        <p>
          Creative, Original and Standout 2D Cartoon Characters that tell a
          story are my strong point and even stronger is my unique style
          language.
        </p>

        <div className="flex flex-col justify-start items-start">
        <p>
          When I'm not drawing, you can find me skating, reading, making music
          or busy at the gym.
        </p>
        <p>Coincidentally, those are the things that inspire me.</p>
        <p>Welcome to my website!</p>
        <p>Cheers,</p>
        </div>

        <p>Uzomadraws</p>
      </div>,
    ],
  },

  {
    id: "socials",
    name: "Contact Me: My Socials",
    description:
      "Want to say hi? Ask questions? Hire me? Or collaboration on a project? Do reach out.",
    isSocials: true,
  },
];
